'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

export default function Error({
    error,
    reset:__,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    const router = useRouter()
    useEffect(() => {
        // Log the error to an error reporting service
        console.error(error);
    }, [error]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
            <div className="text-center px-6 py-12">
                <div className="mb-8">
                    <h1 className="text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-orange-500">
                        500
                    </h1>
                </div>
                <h2 className="text-3xl font-semibold text-white mb-4">
                    Internal Server Error
                </h2>
                <p className="text-gray-400 text-lg mb-8 max-w-md mx-auto">
                    {"Oops! Something went wrong on our end. We're working to fix it."}
                </p>
                <div className="space-x-4">
                    <Link
                        href="/"
                        className="inline-block px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl cursor-pointer"
                    >
                        Go Home
                    </Link>
                    <button
                        onClick={() => router.refresh()}
                        className="inline-block px-6 py-3 bg-gray-700 hover:bg-gray-600 text-white font-medium rounded-lg transition-all duration-200 cursor-pointer"
                    >
                        Try Again
                    </button>
                </div>
            </div>
        </div>);
}
